import React from 'react'
import { connect } from 'react-redux'

import {
  showPopupDialog,
} from 'support/popup_dialogs'
import View from './View'
import ErrorSubmitModal from '../benchprofile/dialogs/ErrorSubmitContainer'
import SucessSubmitModal from '../benchprofile/dialogs/SucessSubmitContainer'
import EditMyProfileDialog from 'pagesNewUi/profile/components/user_detail_section/components/edit_my_profile_dialog'

import { getBenchUserDisplayProfile, getBenchDropdowndatalist, getBenchUserUpdateProfile } from 'services/innovate/bench'
import { getInnovateUserIdeas } from 'services/innovate/idea'


const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  benchUserDisplayProfileResponse: state.data.bench.benchUserDisplayProfile,
  benchUserUpdateProfileResponse: state.data.bench.benchUserUpdateProfile,
  benchUserUpdateProfileLoading: state.data.bench.benchUserUpdateProfileLoading,
  benchUserDisplayProfileLoading: state.data.bench.benchUserDisplayProfileLoading,
  benchDropdownList: state.data.bench.benchDropdownList,
  InnovateUserIdeasList:state.data.InnovateIdea.InnovateUserIdeasList ,
})

const mapDispatchToProps = dispatch => {
  return {
    getInnovateUserIdeas: email => dispatch(getInnovateUserIdeas(email)),
    getBenchUserDisplayProfileFn: (email) => dispatch(getBenchUserDisplayProfile(email)),
    getBenchUserUpdateProfileFn: (email, updateProfile, onSuccessCallback) => {
      const onSuccess = data => {
        const message = 'Your Profile is updated'
        showPopupDialog(<SucessSubmitModal description={message} />, dispatch)
        if (onSuccessCallback) onSuccessCallback()
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
      }
      dispatch(getBenchUserUpdateProfile(email, updateProfile, onSuccess, onFailure))
    },
    getBenchDropdownDatalistFn: () => {
      dispatch(getBenchDropdowndatalist())
    },
    onEditMyProfile: () => showPopupDialog(<EditMyProfileDialog />, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)

